import { Type } from "class-transformer";
import { computed, observable } from "mobx";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import BankCodeType from "./bankCodeType";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class TransferCounterpartyBankResponse {
  @observable
  @Type(() => CounterpartyBankAccountResponse)
  bankAccount?: CounterpartyBankAccountResponse;

  @observable
  name?: string;

  @observable
  cityAddress?: string;

  @observable
  countryCode?: string;

  @observable
  codeType?: BankCodeType;
}

export default class TransferCounterpartyBank extends TransferCounterpartyBankResponse implements IBankAccount {
  @computed
  get accountNumber() {
    return this.bankAccount?.accountNumber;
  }

  set accountNumber(accountNumber) {
    if (!this.bankAccount) {
      this.bankAccount = new CounterpartyBankAccountResponse();
    }
    this.bankAccount.accountNumber = accountNumber;
  }

  @computed
  get bank() {
    return this.bankAccount?.bank ?? "";
  }

  set bank(bank) {
    if (!this.bankAccount) {
      this.bankAccount = new CounterpartyBankAccountResponse();
    }

    this.bankAccount.bank = bank;
  }
}
